import React from "react";
import { Router, Route, browserHistory } from "react-router";
import { render } from "react-dom";
import PartnerApp from "../partner/components/partnerContainer";
import PartnerActivity from "../partner/components/activity";
import PartnerProfile from "../partner/components/profile";
import PartnerDashboard from "../partner/components/dashboard";
import PartnerRecentDonations from "../partner/components/recentdonations";
import PPGFActivity from "../ppgf/components/activity";
import PPGFDashboard from "../ppgf/components/dashboard";
import TrackDonationApp from "../trackdonation/components/trackdonationContainer";
import CharitySetup from "../giftaid/components/charitysetup";
import Giftaid8Ball from "../giftaid/components/declaration";
import GetStarted from "../ppcc/confirmation/components/getStarted";
import ConfirmCharity from "../ppcc/confirmation/components/confirmationHome";
import Consent from "../ppcc/confirmation/components/consent";
import Token from "../ppcc/confirmation/components/tokenCollection";
import { allowedCountryList } from "../../../constants/constants_ppcc";
import DirectmodelHome from "../directmodel/components/home";
import DirectmodelEnroll from "../directmodel/components/enroll";
import DirectmodelTermsandConditions from "../directmodel/components/termsandconditions";

let countryCodeByUser = window.location.pathname.split("/")[1].toUpperCase(),
	countryCode = '';

	if (allowedCountryList.indexOf(countryCodeByUser) >= 0) {
		countryCode = '/' + countryCodeByUser;
	}

let routes = [{ path: '/givingfund/partner', component: PartnerApp }, 
			{ path: '/givingfund/partner/activity', component: PartnerActivity }, 
			{ path: '/givingfund/partner/dashboard', component: PartnerDashboard }, 
			{ path: '/givingfund/partner/recentdonations', component: PartnerRecentDonations }, 
			{ path: '/givingfund/partner/profile', component: PartnerProfile }, 
			{ path: '/givingfund/giftaid/charitydecl', component: CharitySetup }, 
			{ path: '/givingfund/giftaid/declaration', component: Giftaid8Ball }, 
			{ path: countryCode + '/givingfund/activity', component: PPGFActivity },
			{ path: countryCode + '/givingfund/dashboard', component: PPGFDashboard },
			{ path: countryCode + '/givingfund/donationtracker', component: TrackDonationApp }, 
			{ path: countryCode + '/givingfund/donationtrackermember', component: TrackDonationApp }, 
			{ path: countryCode + '/givingfund/ppcc', component: GetStarted },
			{ path: countryCode + '/charities', component: GetStarted }, 
			{ path: countryCode + '/givingfund/ppcc/getStarted', component: GetStarted }, 
			{ path: countryCode + '/charities/getStarted', component: GetStarted }, 
			{ path: countryCode + '/givingfund/ppcc/dashboard', component: ConfirmCharity },
			{ path: countryCode + '/charities/dashboard', component: ConfirmCharity }, 
			{ path: countryCode + '/givingfund/ppcc/consent', component: Consent }, 
			{ path: countryCode + '/charities/consent', component: Consent },
			{ path: countryCode + '/givingfund/ppcc/collecttoken', component: Token }, 
			{ path: countryCode + '/charities/collecttoken', component: Token },
			{ path: countryCode + '/givingfund/', component: DirectmodelHome },
			{ path: countryCode + '/givingfund/home', component: DirectmodelHome },
			{ path: countryCode + '/givingfund/enroll', component: DirectmodelEnroll },
			{ path: countryCode + '/givingfund/termsandconditions', component: DirectmodelTermsandConditions}];
let routeComponents = routes.map(({path, component}, key) => <Route path={path} component={component} key={key} />);
render((
	<Router history={browserHistory}>
        {routeComponents}
	</Router>
), document.getElementById('givingfundWrapper'));


// WEBPACK FOOTER //
// ./routes/router.js